import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
  type InputSignal,
  type OutputEmitterRef,
  type Signal,
} from '@angular/core';
import { UiIconButtonVariant } from '../../types/ui-icon-button-variant.type';

type UiIconButtonType = 'button' | 'submit' | 'reset';

@Component({
  selector: 'ui-icon-button',
  imports: [],
  templateUrl: './ui-icon-button.component.html',
  styleUrl: './ui-icon-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiIconButtonComponent {
  public readonly ariaLabel: InputSignal<string> = input.required<string>();
  public readonly variant: InputSignal<UiIconButtonVariant> = input<UiIconButtonVariant>('ghost');
  public readonly type: InputSignal<UiIconButtonType> = input<UiIconButtonType>('button');
  public readonly disabled: InputSignal<boolean> = input<boolean>(false);
  public readonly pressed: OutputEmitterRef<void> = output<void>();

  protected readonly isGhost: Signal<boolean> = computed((): boolean => this.variant() === 'ghost');
  protected readonly isSoft: Signal<boolean> = computed((): boolean => this.variant() === 'soft');
  protected readonly isSolid: Signal<boolean> = computed((): boolean => this.variant() === 'solid');

  protected handleClick(event: MouseEvent): void {
    if (this.disabled()) {
      event.preventDefault();
      return;
    }

    this.pressed.emit();
  }
}
